/** Joins class names, skipping falsy ones. No merging: callers here never
 *  pass a class that conflicts with a component's own. */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
